export default class SPFCartIndexHelper {

    constructor(store, component) {
        this.store = store;
        this.component = component;
    }

    onRemoveSelectedFromBasketClick() {
        var ids = this.component.getSelectedRowIds().map(Number);
        this.store.removeFromBasketMany(ids);
        const temp = this.component.tableRef.current.state.manuallyChangedRows;
        ids.forEach(x => {
            temp[x] = false
        });

        this.component.tableRef.current.setState({
            manuallyChangedRows: temp
        }, () => {
            this.component.props.onRemoveSelectedFromBasketClick(this.component);
        })
    }
}